<app-question-card class="bottom-gradient">
  <p question>Do any of these apply to the home?</p>
  <div class="form-field" input-options>
    <div class="checkbox-option mb-3" *ngFor="let option of homeFeatureOptions">
      <input type="checkbox" [id]="option.name" name="home-buy" [value]="option.value" [(ngModel)]="option.selected" />
      <label [for]="option.name">
        <app-icon class="tick">tick</app-icon>
        {{ option.name }}
      </label>
    </div>
  </div>
  <div answer>
    <ng-container *ngFor="let option of homeFeatureOptions">
      <div class="answer-option mb-3" *ngIf="option.selected">{{ option.name }}</div>
    </ng-container>
  </div>
  <button class="w-100" footer (click)="next()">Continue</button>
</app-question-card>
